import React, { useState } from "react";
import CookBook from "../components/CookBook";
import Header from "../components/Header";
import Layout from "../components/Layout";

export default function PersonalCookbook() {
  const [isDragging, setIsDragging] = useState(false);
  return (
    <Layout isDragging={isDragging}>
      <CookBook isDragging={isDragging} setIsDragging={setIsDragging} />
    </Layout>
  );
}
